var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[_vm.$style.tool, _vm.toolSelected === _vm.name ? _vm.$style.selected : ''],on:{"click":_vm.onClick}},[_c('BaseIcon',{attrs:{"name":_vm.name}}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }